import { __decorate } from "tslib";
import { Vue, Component, Mixins } from 'vue-property-decorator';
import FormQuiz from '@/components/FormQuiz.vue';
import StepsQuiz from '@/components/StepsQuiz.vue';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['videoLink', 'quiz']),
        ...dataMapper.mapGetters(['quizAnswer'])
    },
    methods: {
        ...dataMapper.mapMutations(['updateQuizField', 'clearQuiz'])
    }
});
let BlockQuiz = class BlockQuiz extends Mixins(UiMappers, DataMappers) {
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    created() {
        this.clearQuiz;
    }
    onCloseClick() {
        this.$emit('closeClicked');
    }
};
BlockQuiz = __decorate([
    Component({
        components: {
            FormQuiz,
            StepsQuiz
        },
    })
], BlockQuiz);
export default BlockQuiz;
